import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    maxWidth: 800,
  },
  row: {
    flexDirection: 'row',
  },
  label: {
    marginRight: Spacing.M,
    minWidth: 100,
  },
  text: {
    color: Color.simplyWhite,
  },
})

interface Props extends ViewProps {}

const LoggingHelp = (props: Props) => {
  const { style, ...otherProps } = props
  const { t } = useTranslation()

  const info = [
    {
      label: t('Received at'),
      description: t(
        'Timestamp that indicates the moment in which the information was received (cloud receive time of event).',
      ),
    },
    {
      label: t('Sent at'),
      description: t(
        'Timestamp provided by device that indicates the moment in which information was obtained (event sample time).',
      ),
    },
    {
      label: t('Occupied'),
      description: t('Indicates whether the sensor detects presence (1) or not (0).'),
    },
    {
      label: t('Charging'),
      description: t('Indicates whether the device is used for wireless charging (1) or not (0).'),
    },
    {
      label: t('Led cnnct'),
      description: t('Indicates whether a Led-ring is connected (1) or not (0).'),
    },
    {
      label: t('Prscn cnnct'),
      description: t('Indicates whether the presence sensor is connected (1) or not (0).'),
    },
    {
      label: t('PDP'),
      description: t('Indicates whether a new PDP session was initiated for this transmission (1) or not (0).'),
    },
    {
      label: t('Power cycle'),
      description: t('Indicates whether the device had a new power cycle (1) or not (0).'),
    },
    {
      label: t('CSQ'),
      description: t(
        'Returns the signal strength of the transmission of the registered network at the device. The received signal strength ranges from 0 being marginal (-113 dBm and lower) to 30 being excellent (-51 dBm and higher). Value is 99 if the signal strength is not known or not detectable.',
      ),
    },
    {
      label: t('Firmware'),
      description: t('Indicates the of firmware version embedded into the device.'),
    },
  ]
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {info.map((item) => (
        <View style={styles.row} key={item.label}>
          <Text level={5} style={[styles.text, styles.label]}>
            {item.label}
          </Text>
          <Text style={styles.text}>{item.description}</Text>
        </View>
      ))}
    </View>
  )
}

export default LoggingHelp
